export default [
    {
        path: '/',
        name: 'default',
        meta: {
            title: 'Dashboard',
            allowed: ['auth']
        },
        component: () => import('./views/dashboards/Home'),
    },
    // Auth routes
    {
        path: '/login/offline',
        name: 'loginOffline',
        component: () => import('./views/auth/LoginOffline'),
        meta: {
            title: 'Logowanie Offline',
            allowed: ['guest']
        },
    },
    {
        path: '/login/token',
        name: 'loginToken',
        component: () => import('./views/auth/LoginToken'),
        meta: {
            title: 'Logowanie Tokenem',
            allowed: ['guest']
        },
    },
    {
        path: '/createOfflineAccount',
        name: 'createOfflineAccount',
        component: () => import('./views/auth/CreateOfflineAccount'),
        meta: {
            title: 'Tworzenie konta offline',
            allowed: ['guest']
        },
    },
    {
        path: '/logout',
        name: 'logout',
        component: () => import('./views/auth/Logout'),
        meta: {
            title: 'Wylogowywanie',
            allowed: ['auth']
        },
    },
    // End of auth routes
    
    // Account routes
    {
        path: '/account/registration',
        name: 'account.registration',
        meta: {
            title: 'Proces rejestracji',
            allowed: ['auth'],
            enabledPage: 'registration'
        },
        component: () => import('./views/account/Registration'),
    },
    {
        path: '/account/groups',
        name: 'account.groups',
        meta: {
            title: 'Zmiana grup',
            allowed: ['auth'],
            enabledPage: 'groups'
        },
        component: () => import('./views/account/Groups'),
    },
    {
        path: '/account/private-channel',
        name: 'account.privateChannel',
        meta: {
            title: 'Kanał prywatny',
            allowed: ['auth'],
            enabledPage: 'privateChannel'
        },
        component: () => import('./views/account/PrivateChannel'),
    },
    {
        path: '/account/premium',
        name: 'account.premium',
        meta: {
            title: 'Strefa premium',
            allowed: ['auth'],
            enabledPage: 'premium'
        },
        component: () => import('./views/account/Premium'),
    },
    {
        path: '/account/friends',
        name: 'account.friends',
        meta: {
            title: 'Znajomi',
            allowed: ['auth'],
            enabledPage: 'friends'
        },
        component: () => import('./views/account/Friends'),
    },
    // End of account routes
    
    // Profile
    {
        path: '/profile/:dbid',
        name: 'profile',
        meta: {
            title: 'Profil',
            allowed: ['auth']
        },
        component: () => import('./views/profile/Profile'),
    },
    // End of profile
    
    // Settings
    {
        path: '/settings',
        name: 'settings',
        meta: {
            title: 'Ustawienia',
            allowed: ['auth']
        },
        component: () => import('./views/Settings'),
    },
    // End of settings
    
    // Offline account
    {
        path: '/offline-account',
        name: 'offlineAccount',
        meta: {
            title: 'Konto offline',
            allowed: ['auth']
        },
        component: () => import('./views/OfflineAccount'),
    },
    // End of offline account
    
    // Server routers
    {
        path: '/server/rules',
        name: 'server.rules',
        meta: {
            title: 'Regulamin',
            allowed: ['auth'],
            enabledPage: 'rules'
        },
        component: () => import('./views/server/Rules'),
    },
    {
        path: '/server/faq',
        name: 'server.faq',
        meta: {
            title: 'FAQ',
            allowed: ['auth'],
            enabledPage: 'faq'
        },
        component: () => import('./views/server/Faq'),
    },
    {
        path: '/server/recruitment',
        name: 'server.recruitment',
        meta: {
            title: 'Rekrutacja',
            allowed: ['auth'],
            enabledPage: 'recruitment'
        },
        component: () => import('./views/server/Recruitment'),
    },
    {
        path: '/server/admin-opinions',
        name: 'server.adminOpinions',
        meta: {
            title: 'Oceń admina',
            allowed: ['auth'],
            enabledPage: 'adminOpinions'
        },
        component: () => import('./views/server/AdminOpinions'),
    },
    {
        path: '/server/clans',
        name: 'server.clans',
        meta: {
            title: 'Klany',
            allowed: ['auth'],
            enabledPage: 'clans'
        },
        component: () => import('./views/server/Clans'),
    },
    {
        path: '/server/clans/:id',
        name: 'server.clans.single',
        meta: {
            title: 'Klan',
            allowed: ['auth'],
            enabledPage: 'clans'
        },
        component: () => import('./views/server/ClanSingle'),
    },
    {
        path: '/server/shop',
        name: 'server.shop',
        meta: {
            title: 'Sklep',
            allowed: ['auth'],
            enabledPage: 'shop'
        },
        component: () => import('./views/server/Shop'),
    },
    // End of server routes
    
    // Admin routes
    {
        path: '/admin/admins',
        name: 'admin.admins',
        meta: {
            title: 'Administratorzy',
            allowed: ['auth','admin'],
            perms: ['ADMINS']
        },
        component: () => import('./views/admin/Admins'),
    },
    {
        path: '/admin/news',
        name: 'admin.news',
        meta: {
            title: 'Newsy',
            allowed: ['auth']
        },
        component: () => import('./views/admin/News'),
    },
    {
        path: '/admin/partners',
        name: 'admin.partners',
        meta: {
            title: 'Partnerzy',
            allowed: ['auth']
        },
        component: () => import('./views/admin/Partners'),
    },
    {
        path: '/admin/recruitment',
        name: 'admin.recruitment',
        meta: {
            title: 'Rekrutacja',
            allowed: ['auth']
        },
        component: () => import('./views/admin/Recruitment'),
    },
    {
        path: '/admin/recruitment/:id',
        name: 'admin.recruitment.single',
        meta: {
            title: 'Zobacz podanie',
            allowed: ['auth']
        },
        component: () => import('./views/admin/RecruitmentSingle'),
    },
    {
        path: '/admin/bans',
        name: 'admin.bans',
        meta: {
            title: 'Bany',
            allowed: ['auth']
        },
        component: () => import('./views/admin/Bans'),
    },
    {
        path: '/admin/manage-groups/:dbid?',
        name: 'admin.manageGroups',
        meta: {
            title: 'Zarządzanie grupami',
            allowed: ['auth']
        },
        component: () => import('./views/admin/ManageGroups'),
    },
    {
        path: '/admin/statistics',
        name: 'admin.statistics',
        meta: {
            title: 'Statystyki',
            allowed: ['auth']
        },
        component: () => import('./views/admin/Statistics'),
    },
    {
        path: '/admin/announcements',
        name: 'admin.announcements',
        meta: {
            title: 'Ogłoszenia',
            allowed: ['auth']
        },
        component: () => import('./views/admin/Announcements'),
    },
    {
        path: '/admin/manage-server',
        name: 'admin.manageServer',
        meta: {
            title: 'Zarządzanie serwerem',
            allowed: ['auth']
        },
        component: () => import('./views/admin/ManageServer'),
    },
    {
        path: '/admin/manage-shop',
        name: 'admin.manageShop',
        meta: {
            title: 'Zarządzanie sklepem',
            allowed: ['auth']
        },
        component: () => import('./views/admin/ManageShop'),
    },
    // End of admin routes
    
    // 404 page
    {
        path: '/404',
        name: '404',
        meta: {
            title: 'Error 404',
        },
        component: require('./views/utility/404').default,
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
        path: '*',
        redirect: '404',
    },
    // End of 404 page
]
